import React, { useEffect, useState } from 'react';
import { Table, message, Input, Select, Row, Col } from 'antd';
// import axios from 'axios';
import AppLayout from '../../components/AppLayout';


const JobCardList: React.FC = () => {
  const [jobCards, setJobCards] = useState<any[]>([]);
  const [filteredCards, setFilteredCards] = useState<any[]>([]);
  const [filters, setFilters] = useState({ technician: '', stage: '' });
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    const demoData = Array.from({ length: 50 }, (_, i) => ({
      _id: `${i + 1}`,
      job_card_no: `JC-${(i + 1).toString().padStart(3, '0')}`,
      work_order_no: `WO-${(100 + i).toString()}`,
      technician_name: `Technician ${i + 1}`,
      stage: ['Assembly', 'Quality Check', 'Packaging'][i % 3],
      start_time: `2024-01-${(i % 28 + 1).toString().padStart(2, '0')} 09:00 AM`,
      end_time: `2024-01-${(i % 28 + 1).toString().padStart(2, '0')} 11:00 AM`
    }));

    setJobCards(demoData);
    setFilteredCards(demoData);
    setLoading(false);
  }, []);

  const handleFilterChange = (field: string, value: string) => {
    const newFilters = { ...filters, [field]: value };
    setFilters(newFilters);

    const filtered = jobCards.filter(card =>
      (newFilters.technician === '' || card.technician_name.includes(newFilters.technician)) &&
      (newFilters.stage === '' || card.stage === newFilters.stage)
    );

    setFilteredCards(filtered);
  };

  const columns = [
    { title: 'Job Card Number', dataIndex: 'job_card_no', key: 'job_card_no' },
    { title: 'Work Order No', dataIndex: 'work_order_no', key: 'work_order_no' },
    { title: 'Technician', dataIndex: 'technician_name', key: 'technician_name' },
    { title: 'Stage', dataIndex: 'stage', key: 'stage' },
    { title: 'Start Time', dataIndex: 'start_time', key: 'start_time' },
    { title: 'End Time', dataIndex: 'end_time', key: 'end_time' },
  ];

  return (
    <AppLayout>
      <Row gutter={16} style={{ marginBottom: 16 }}>
        <Col span={12}>
          <Input
            placeholder="Search Technician"
            value={filters.technician}
            onChange={(e) => handleFilterChange('technician', e.target.value)}
          />
        </Col>
        <Col span={12}>
          <Select
            placeholder="Select Stage"
            value={filters.stage}
            onChange={(value) => handleFilterChange('stage', value)}
            allowClear
            style={{ width: '100%' }}
          >
            <Select.Option value="Assembly">Assembly</Select.Option>
            <Select.Option value="Quality Check">Quality Check</Select.Option>
            <Select.Option value="Packaging">Packaging</Select.Option>
          </Select>
        </Col>
      </Row>
      <Table
        loading={loading}
        dataSource={filteredCards}
        columns={columns}
        rowKey="_id"
        pagination={{ pageSize: 10 }}
      />
    </AppLayout>
  );
};

export default JobCardList;